module.exports = __webpack_public_path__ + "img/Africanbar.27391c36.svg";